import CloseCard from './CloseCard';

export default CloseCard;
